import { render } from "./MessageGroupChatCreate.vue?vue&type=template&id=50f74c54&scoped=true&ts=true"
import script from "./MessageGroupChatCreate.vue?vue&type=script&lang=ts"
export * from "./MessageGroupChatCreate.vue?vue&type=script&lang=ts"

import "./MessageGroupChatCreate.vue?vue&type=style&index=0&id=50f74c54&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f74c54"]])

export default __exports__